<template>
    <v-chart :option="chartOptions" class="chart" autoresize />
</template>

<script>
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, GridComponent, LegendComponent } from 'echarts/components'

use([
    CanvasRenderer,
    BarChart,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LegendComponent
]);

export default {
    name: 'ChartLine',
    components: {
        VChart
    },
    props: {
        chartTitle: {
            type: String,
            required: true,
        },
        legendText: {
            type: String,
            required: true,
        },
        xAxisData: {
            type: Array,
            required: true
        },
        xAxisLegend: {
            type: String,
            required: true
        },
        yAxisData: {
            type: Array,
            required: true
        },
        yAxisLegend: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            chartOptions: {
                title: {
                    text: this.chartTitle,
                },
                tooltip: {},
                legend: { data: [this.legendText] },
                xAxis: {
                    data: this.xAxisData,
                    // Custom label
                    name: this.xAxisLegend,
                    nameLocation: 'middle',
                    nameGap: 40,
                    nameTextStyle: {
                        fontSize: 15,
                        color: '#333'
                    },
                },
                yAxis: {
                    name: this.yAxisLegend,
                    nameLocation: 'middle',
                    nameGap: 40,
                    nameTextStyle: {
                        fontSize: 15,
                        color: '#333'
                    },
                },
                series: [
                    {
                        name: this.legendText,
                        type: 'bar',
                        data: this.yAxisData,
                        itemStyle: {
                            color: '#ff5555'
                        }
                    }
                ]
            }
        }
    }
}
</script>

<style scoped>
.chart {
    width: 100%;
    height: 400px;
}
</style>